import { render, staticRenderFns } from "./energy-value.vue?vue&type=template&id=563229de&scoped=true&"
import script from "./energy-value.vue?vue&type=script&lang=js&"
export * from "./energy-value.vue?vue&type=script&lang=js&"
import style0 from "./energy-value.vue?vue&type=style&index=0&id=563229de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563229de",
  null
  
)

export default component.exports